<template>
<div class="panelNagusia">
  <div class="ui breadcrumb">
    <a class="section" v-on:click="goTo('/dashboard')">Home</a>
    <i class="right angle icon divider"></i>
    <a class="section" v-on:click="goTo('/users')">Usuarios</a>
    <i class="right angle icon divider"></i>
    <a class="active section">Añadir Usuario</a>
  </div>
  <h1 class="ui header"><i class="icon user"></i>
    <div class="content">Añadir Usuario</div>
  </h1>
  <button class="ui basic button rightButton" v-on:click="goTo('/users')">
    <i class="long arrow alternate left icon"></i>Atras
  </button>
  <div class="ui stackable two column divided grid container">
    <div class="row">
      <div class="column">
        <form class="ui form" @submit.prevent="newUser">
          <h4 class="ui dividing header">Información del usuario</h4>
          <div class="inline field">
            <sui-checkbox label="Activo" toggle v-model="newUserData.active" />
          </div>
          <div class="inline field">
            <sui-checkbox label="Acceso al admin" toggle v-model="newUserData.login_admin" />
          </div>
          <div class="inline field">
            <sui-checkbox label="Virtual Sesión" toggle v-model="newUserData.virtualSession" />
          </div>
          <div class="field">
            <label>Nombre y Apellido *</label>
            <input type="text" v-model="newUserData.name" placeholder="Nombre y Apellido" required>
          </div>
          <div class="two fields">
            <div class="field">
              <label>Username *</label>
              <input type="text" v-model="newUserData.username" placeholder="Username" required>
            </div>
            <div class="field">
              <label>Password *</label>
              <input type="text" v-model="newUserData.password" placeholder="Password" required>
            </div>
          </div>
          <div class="field">
            <label>Email *</label>
            <input type="text" v-model="newUserData.email" placeholder="Email" required pattern="^[a-zA-Z0-9._-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$">
          </div>          
          <div class="field">
            <label>Imagen para el Avatar</label>
            <input type="file" accept="image/*" @change="onFilePicked">
          </div>
          <div class="two fields">
            <div class="field">
              <label>Compañía *</label>
              <sui-dropdown placeholder="Compañía" search selection :options="companyOptions" v-model="newUserData.company_id" required />
            </div>
            <div class="field">
              <label>Rol *</label>
              <sui-dropdown placeholder="Rol" search selection :options="roleOptions" v-model="newUserData.role" required/>
            </div>
          </div>
          <div class="field">
            <label>Selecciona las Taquillas *</label>
            <sui-dropdown id="taquillas" search fluid multiple :options="apmOptions" placeholder="Taquillas" selection v-model="newUserData.apms" />
          </div>
          <div class="field">
            <label>* Campos obligatorios</label>
          </div>          
          <button id="generate" class="ui button" type="submit">Crear</button>
        </form>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import { hapiickApi } from '@/api/hapiickApi';
export default {
  name: 'addUser',
  data() {
    return {
      apms: null,
      companies: null,
      newUserData: {
        name: null,
        username: null,
        password: null,
        email: null,
        role: null,
        company_id: null,
        image: null,
        apms: null,
        active: 1,
        virtualSession: 0,
        login_admin: 1
      },
      show: false,
      roleOptions: [],
      companyOptions: [],
      apmOptions: [],
    }
  },
  created() {
    let role = JSON.parse(localStorage.admin).role
    if (role === 'master' || role === 'admin') {
      this.getRoles()
      this.getCompanies()
      let _this = this
      setTimeout(function() {
        _this.fillCompanyOptions()
      }, 2000)
    } else {
      this.$router.replace('/parcels_v2')
    }
  },
  watch: {
    'newUserData.company_id': function(new_company, old_company) {
      this.newUserData.apms = null;
      this.newUserData.role = null;
      this.apmOptions = [];
      this.getApms(new_company);
    },
    'newUserData.role': function(new_role, old_role) {
      //Si el rol seleccionado en el combo es uno de estos, asignaremos todas las apts que se han cargado en el combo de apts
      if(new_role === 'apiclientAdmin' || new_role === 'staffappmediamarktAdmin' || new_role === 'master' || new_role === 'admin' || new_role === 'sabico' || new_role === 'cau') {
        this.newUserData.apms = this.apmOptions.map((a) => a['key']);
      } else {
        //Vaciamos la seleccion de apts del combo
        this.newUserData.apms = null;
      }
    }
  },
  methods: {
    getRoles() {
      this.axios.get("static/roles.json")
      .then(response => {
        const roles = response.data.roles.actives;
        const rolNotUse = ['shophapiickPoint']; //filtro para quitar de roles los roles que no nos interesen (ej: shophapiickPoint)

        let rolesCombo = roles.filter(rol => {
          return !rolNotUse.includes(rol)
        })
        const roleOptions = rolesCombo.map((role) => ({text: role, value: role}))
        this.roleOptions = roleOptions.sort((a, b) => {
          if ( a.text < b.text ){
            return -1;
          }
          if ( a.text > b.text ){
            return 1;
          }
          return 0;})
      })
      .catch((request) => console.log('error getting roles: ' . request));
    },
    getApms(companyId) {
      hapiickApi().post('/v1/apms/companies', {
          admin_id: JSON.parse(localStorage.admin).id,
          companyId: companyId
        })
        .then(request => {
          this.apms = JSON.parse(JSON.stringify(request.data.data.apms))
          this.fillApmOptions();
        })
        .catch(() => console.log('error getting apms'))
    },
    getCompanies() {
      hapiickApi().post('/v2/companies', {
          admin_id: JSON.parse(localStorage.admin).id,
          soloActivas: true
        })
        .then(request => {
          this.companies = JSON.parse(JSON.stringify(request.data.data.companies))
        })
        .catch(() => console.log('error getting companies'))
    },
    newUser() {
      let x = document.getElementById("generate");
      x.classList.add("loading");
      x.disabled = true;

      hapiickApi().post('/v2/users/add', {
        admin_id: JSON.parse(localStorage.admin).id,
        newUserData: this.newUserData
      })
      .then(request => this.userSaved(request))
      .catch(() => this.$swal({
        type: 'error',
        title: 'Error',
        text: 'No se han podido guardar los datos'
      }))
    },
    goTo(where) {
      this.$router.push(where)
    },
    fillCompanyOptions() {
      for (let i = 0; i < this.companies.length; i++) {
        this.companyOptions.push({
          text: this.companies[i].AdminCompany.name,
          value: this.companies[i].AdminCompany.id
        })
      }
    },
    fillApmOptions() {
      for (let i = 0; i < this.apms.length; i++) {
        this.apmOptions.push({
          key: this.apms[i].Apt.id,
          text: this.apms[i].Apt.LanguagesApts[0].name,
          value: this.apms[i].Apt.id
        })
      }
    },
    onFilePicked(event) {
      const files = event.target.files
      let filename = files[0].name
      if (filename.lastIndexOf('.') <= 0) {
        return alert('Please add a valid file!')
      }
      const fileReader = new FileReader()
      fileReader.addEventListener('load', () => {
        this.newUserData.image = fileReader.result
      })
      fileReader.readAsDataURL(files[0])
    },
    userSaved(req) {
        let x = document.getElementById("generate");
        x.classList.remove("loading");
        x.disabled = false;

      let msg='';
      if (req.data.status !== 'OK') {
        if (req.data.status === 'KO') {
          msg = req.data.message;
        } else {
          msg = 'No se han podido guardar los datos';
        }

        this.$swal({
          type: 'error',
          title: 'Error',
          text: msg
        })
      } else {
        this.$swal({
          type: 'success',
          title: 'Los datos se han guardado correctamente',
          showConfirmButton: false,
          timer: 2500
        })
        this.newUserData = null
        this.goTo('/users')
      }
    },
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Users/addUser.vue